
<template>
  <div v-if="isAllowed"
    style="background:url('../static/other/bg.png') ; background-size: 100%;background-repeat:no-repeat;text-align:"  
  >
 
    <div id="banner">
      <div style="height:20%"></div>
      <div class="login_warp">
        <div class="loginbox fl">
          <div class="login_header">
            <span  :class="{active:true}">账号登录</span>
          </div>
          <div class="login_content">
            <div  class="Cbody_item">
              <v-form direction="horizontal">
                <!-- <v-form-item label="用户名"   :label-col="labelCol" :wrapper-col="wrapperCol"> -->
                  <v-input placeholder="请输入用户名" size="large" v-model="query_param.username"></v-input>
                <!-- </v-form-item> -->
                <!-- <v-form-item label="密码" :label-col="labelCol" :wrapper-col="wrapperCol"> -->
                  <br /><br />
                  <v-input
                    type="password"
                    placeholder="请输入密码"
                    size="large"
                    v-model="query_param.password"
                  ></v-input>
                <!-- </v-form-item> -->
              </v-form>
               <br /><br />
               <!-- <a href="/doc">用户手册</a> -->
              <v-button style="margin-left:43%" type="primary" @click="next(1)">登录</v-button>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <h2>对不起，您的IP地址不被允许访问此页面。</h2>
  </div>
</template>
<script>

let query_param = {
  username: "",
  password: ""
};
export default {
  data() {
    return {
      isshow:true,
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 14
      },
      query_param,
     
    };
  },
  created(){
    this.test()
  },
  computed:{
    isAllowed(){
        if(this.isshow){
          return true
        }else{
          return false
        }
    }
  },
  mounted() {
    document.getElementById("banner").style.height =
      window.screen.height - 110 + "px";
       // 绑定enter事件
    this.enterKeyup();
  },
   destroyed() {
    // 销毁enter事件
    this.enterKeyupDestroyed();
  },
  methods: {
    test() {
      //return true
      this.$axios.get("api/system/auth/get-bj", this.query_param).then(res => {
        if(res.data.code == 200){
          if(res.data.data){
            this.isshow = true
          }else{
             this.isshow = false
          }
        }else{
          this.isshow = false
        }
      })
      
    },
    next(index) {
      this.$axios.post("api/system/auth/login", this.query_param).then(res => {
        if(res.data.code == 200){
          // 
          this.$message["success"]("登录成功！");
          localStorage.setItem("islogin", res.data.token);
          sessionStorage.setItem("token", res.data.token);
          sessionStorage.setItem("username", this.query_param.username);
          window.location.href = "/homepage";
        }
        else{
           this.$message["error"](res.data.message);
        }
      });
    },
    enterKey(event) {
      const code = event.keyCode
        ? event.keyCode
        : event.which
        ? event.which
        : event.charCode;
      if (code == 13) {
        this.next(1);
      }
    },
    enterKeyupDestroyed() {
      document.removeEventListener("keyup", this.enterKey);
    },
    enterKeyup() {
      document.addEventListener("keyup", this.enterKey);
    }

  }
};
</script>
<style scoped>
.main {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.test {
  background-color: white;
  display: inline-block;
  padding: 5px 10px 6px;
  text-decoration: none;
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  text-shadow: 0 -1px 1px rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  position: relative;
  cursor: pointer;
}

.fl {
  float: left;
}
.fr {
  float: right;
}
.clear {
  clear: both;
}
a {
  text-decoration: none;
  color: #333;
  transition: ease all 0.5s;
}
a {
  color: white;
}
.login_header {
  margin-bottom: 40px;
}
.login_header span {
  margin-right: 20px;
  cursor: pointer;
}
.loginbox {
  width: 100%;
  overflow: hidden;

  padding: 20px;
  padding-top: 15px;
  background-color: transparent;
}
.Cbody_item {
  border: 0px solid #999;
  overflow: hidden;
}
.form_item {
  font-size: 13px;
}
.form_item input[type="text"],
.form_item input[type="password"] {
  display: block;
  width: calc(100% - 18px);
  height: 36px;
  margin: 0 auto;
  padding-left: 16px;
  outline: none;
  border: 1px solid #999;
  transition: ease all 0.5s;
  margin-bottom: 20px;
}
.form_item input[type="text"]:focus,
.form_item input[type="password"]:focus {
  border: 1px solid #1c65ff;
}
.form_item input[type="submit"] {
  display: block;
  width: calc(100% - 0px);
  height: 40px;
  margin: 0 auto;
  padding-left: 16px;
  outline: none;
  border: 1px solid #1c65ff;
  transition: ease all 0.5s;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #1c65ff;
  color: #fff;
  cursor: pointer;
}
.form_item input[type="submit"]:hover {
  background-color: #3f7dff;
  border: 1px solid #3f7dff;
}
.active {
  color: white;
  padding-bottom: 10px;
  border-bottom: 3px solid white;
}
.loginrslider {
  width: 160px;
  height: 22px;
  background-color: #1c65ff;
}
.login_warp {
  width: 500px;
  /* margin: 0px auto; */
  border-radius: 10px;
  box-shadow: 0 0px 0px #ccc;
  overflow: hidden;
  /* float: right; */
   margin:0 auto;
  transition: ease all 0.5s;
  position: relative;
  top: 0px;
  cursor: pointer;
}
.login_warp {
 
  box-shadow: 0 15px 21px #ccc;
}
.loginrslider {
  color: #fff;
}
.qcode {
  width: 160px;
  height: 160px;
  background-color: #ccc;
  margin: 0 auto;
  margin-top: 2px;
}
.beizhu {
  text-align: center;
  font-size: 13px;
  margin-top: 10px;
  color: #999;
}
#slider {
  /*margin: 100px auto;*/
  width: 268px;
  height: 38px;
  position: absolute;
  border-radius: 2px;
  background-color: gainsboro;
  overflow: hidden;
  text-align: center;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}

#slider_bg {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #7ac23c;
  z-index: 1;
}

#label {
  width: 46px;
  position: absolute;
  left: 0;
  top: 0;
  height: 38px;
  line-height: 38px;
  border: 1px solid #ccc;
  background: #fff;
  z-index: 3;
  cursor: move;
  color: #ff9e77;
  font-size: 16px;
  font-weight: 900;
}

#labelTip {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 13px;
  font-family: microsoft yahei, serif;
  color: #787878;
  line-height: 38px;
  text-align: center;
  z-index: 2;
}
label{
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/view/login.vue